import {PaginatedRequest} from "../../../models/core/paginated.request";
import {FieldState, FieldStateGroup} from "../../../models/filter/filter.field.state";
import {FieldGroupSnapshot} from "../../../models/filter/filter.field.snapshot";
import {fieldTypes} from "../../../models/filter/filter.field.type.config";
import {FieldRuleName, filterRuleMap} from "../../../models/filter/filter.field.rule";

export function toValues(request: PaginatedRequest, stateGroups: FieldStateGroup[]) {

    return {
        page: request.page,
        limit: request.limit,
        filter: buildUrlQueryFilterString(stateGroups)
    }
}

export function fromValues(urlParams: Record<string, any>) {
    const request = new PaginatedRequest();
    const params = {...urlParams};

    request.page  = parseInt(urlParams.page as string) || 1;
    request.limit = parseInt(urlParams.limit as string) || 20;

    delete params.page;
    delete params.limit;

    return request
}

export function getSnapshotFromUrl(filter: string): FieldGroupSnapshot[] {
    const snapshotGroups: FieldGroupSnapshot[] = [];

    filter.split("&").forEach((item: string) => {
        const [groupName, rest]: string[] = item.split("__");
        const [fieldName, valueAndRule] = rest.split("=");
        const [value, rule] = valueAndRule.split("|");
        let snapshotGroup = snapshotGroups.find((item) => item.name === groupName);

        if (!snapshotGroup) {
            snapshotGroup = {
                name: groupName,
                snapshots: [],
            };
            snapshotGroups.push(snapshotGroup);
        }

        snapshotGroup.snapshots.push({
            rule: findRule(rule),
            value: decodeURIComponent(value),
            name: fieldName,
        });
    });
    return snapshotGroups;
}

export function buildUrlString(group: FieldStateGroup, state: FieldState, valuesString: string): string {
    let urlString = group.name + "__" + state.config.name + "=" + encodeURIComponent(valuesString);
    if (fieldTypes[state.config.type].supportedRules.length > 0) {
        urlString += "|" + state.rule;
    }
    return urlString;
}

export function buildUrlQueryFilterString(filters: FieldStateGroup[]): string {
    const serializeStrings: string[] = [];

    filters.forEach((group) => {
        group.states.forEach((state) => {
            serializeStrings.push(
                buildUrlString(group, state, fieldTypes[state.config.type].toUrl(state))
            );
        });
    });

    return serializeStrings.join("&");
}

export function findRule(rule: string): FieldRuleName | undefined {
    for (const ruleKey in filterRuleMap) {
        if (filterRuleMap[ruleKey as FieldRuleName].value === rule) {
            return ruleKey as FieldRuleName;
        }
    }
    return undefined;
}